import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=09a7ea9a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=09a7ea9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a7ea9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a7ea9a')) {
      api.createRecord('09a7ea9a', component.options)
    } else {
      api.reload('09a7ea9a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=09a7ea9a&scoped=true&", function () {
      api.rerender('09a7ea9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dpxi6rDZta8R/JS/comp/CookieBox.vue"
export default component.exports